import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SamparkEolPageComponent } from './sampark-eol-page.component';

const routes: Routes = [
  {
    path: 'sampark-eol-page',
    data: { name: 'Sampark EOL', isTab: false },
    component: SamparkEolPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SamparkEolPageRoutingModule {}
